import React, { useState } from 'react';
import './SignupSurvey.scss';

export const SignupSurvey: React.FC = () => {
  const [open, setOpen] = useState(true);

  return (
    <>
      {open && (
        <div className={'signup-survey'}>
          <div className={'signup-survey-title'}>Can you help? (takes about 30 seconds)</div>
          <div className={'signup-survey-description'}>
            This tiny project has turned up some deep insights. But how does using data this way make us feel? Your
            answers would be invaluable
          </div>
          <div className={'signup-survey-actions'}>
            <a
              className={'signup-survey-actions-ask'}
              href={'https://www.surveymonkey.co.uk/r/LSDCVZM'}
              target={'_blank'}
              rel="noopener noreferrer"
            >
              Ask away
            </a>
            <button className={'signup-survey-actions-dismiss'} onClick={() => setOpen(false)}>
              No, thank you
            </button>
          </div>
        </div>
      )}
    </>
  );
};
